        <ng-container *ngIf="health as health; else unrecordedExport">
          <strong [class.export-failed]="health.status === 'failed'">
            {{health.status === 'failed' ? 'Export failed' : 'Delivered'}}
          </strong>
          <div>{{health.attemptedAt | date:'medium'}}</div>
          <ng-container *ngIf="health.status === 'failed'">
            <div>{{health.message}}</div>
            <div>Reason: {{health.reason}}<span *ngIf="health.httpStatus"> (HTTP {{health.httpStatus}})</span></div>
            <div>Failing since: {{health.firstFailedAt | date:'medium'}}</div>
            <div>Consecutive failures: {{health.consecutiveFailures}}</div>
            <div>{{health.action}}</div>
          </ng-container>
          <div>Last successful export: {{health.lastSuccessfulAt ? (health.lastSuccessfulAt | date:'medium') : 'Not recorded'}}</div>
          <div *ngIf="health.lastFailure">Last failure: {{health.lastFailure.attemptedAt | date:'medium'}} ({{health.lastFailure.stage}})</div>
          <div>Records in batch: {{health.recordCount}}</div>
          <div class="batch-id">Batch: {{health.batchId}}</div>
        </ng-container>
        <ng-template #unrecordedExport>Not recorded</ng-template>
